import { proxiedGet } from '@/core/http/api-client'
import { getFeelGreatApiUrl } from '@/core/http/http-helper'
import type { FetchSettingsParams } from '@/core/http/http-helper'
import type { FGSettings } from './feelgreat.types'

export const fetchFeelGreatSettings = (paramsOrCountry: FetchSettingsParams | string, baStatus?: string): Promise<FGSettings> =>
    proxiedGet<FGSettings>(getFeelGreatApiUrl(paramsOrCountry, baStatus))
